import parseClassNames from 'classnames'
import { DetailedHTMLProps, InputHTMLAttributes } from 'react'

import { BaseCheckboxColor } from './base-checkbox-color.enum'

export type CheckboxPropTypes = {
  label?: string | JSX.Element
  labelDir?: 'left' | 'right'
  color?: BaseCheckboxColor
  inputClassName?: string
  labelClassName?: string
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

const BaseCheckbox = (props: CheckboxPropTypes) => {
  const {
    label,
    labelDir = 'left',
    className,
    color = BaseCheckboxColor.Blue,
    inputClassName,
    labelClassName,
    ...restProps
  } = props

  const getColorClassNames = () => {
    switch (color) {
      case BaseCheckboxColor.Blue:
        return 'checked:bg-[#0086B3] hover:text-[#0086B3] focus:text-[#0086B3] focus-visible:accent-[#0086B3] text-[#0086B3]'
      case BaseCheckboxColor.PersianBlue:
        return 'checked:bg-[#109CF1] checked:border-none hover:text-[#109CF1] focus:text-[#109CF1]  text-[#109CF1] '
      case BaseCheckboxColor.Red:
        return 'checked:bg-red-500 hover:text-red-500  focus:text-red-500 focus-visible:accent-red-500 text-red-500'

      default:
        return ''
    }
  }

  return (
    <div
      className={`flex justify-start items-center w-full ${className || ''}`}
    >
      {labelDir === 'right' &&
        (typeof label === 'object' ? (
          label
        ) : (
          <span
            className={parseClassNames(
              'w-full text-strong-body ml-3',
              labelClassName
            )}
          >
            {label}
          </span>
        ))}
      <input
        type="checkbox"
        className={parseClassNames(
          'w-6 h-6 !ring-0 !ring-offset-0 cursor-pointer border-[#D8D8D8] !rounded-1 bg-[#FCFCFC]',
          getColorClassNames(),
          restProps.checked ? 'element-checkbox-checked' : '',
          inputClassName
        )}
        {...restProps}
      />
      {labelDir === 'left' &&
        (typeof label === 'object' ? (
          label
        ) : (
          <span
            className={parseClassNames(
              'w-full text-strong-body mr-3',
              labelClassName
            )}
          >
            {label}
          </span>
        ))}
    </div>
  )
}

export default BaseCheckbox
